import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import {
  Button,
  FormControl,
  MenuItem,
  Select,
  Stack,
} from '@mui/material'
import { useAppServices, useUploadImage } from 'hook/services'
import MDInput from 'components/MDInput'
import Multiselect from '../CreateModal/components/Multiselect'
import { useAgencyInfo } from 'context/agency'
import Editor from 'components/editor'

const EditModal = ({ data, handleRefresh, teamTags, apps }) => {
  console.log(data, "data")
  const [agency] = useAgencyInfo()
  const [open, setOpen] = useState(false)
  const [processing, setProcessing] = useState(false)
  const uploadImage = useUploadImage()
  const AppService = useAppServices()

  // Form states
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [selectedRoles, setSelectedRoles] = useState([])
  const [selectedGeneralType, setSelectedGeneralType] = useState('')
  const [selectedTags, setSelectedTags] = useState([])
  const [selectedApps, setSelectedApps] = useState([])
  const [liveOnApp, setLiveOnApp] = useState('no')
  const [description, setDescription] = useState('')
  const [calendar, setCalendar] = useState('')
  const handleRoleChange = (selected) => {
    setSelectedTags(selected.map((item) => item.value))
  }

  // Prepare dropdown data
  const generalTypes = [
    { label: 'Founder & CEO', value: 'Founder & CEO' },
    { label: 'Co Founder & CTO', value: 'Co Founder & CTO' },
    { label: 'Senior Developer', value: 'senior-developer' },
    { label: 'Developer', value: 'developer' },
    { label: 'Graphic Designer', value: 'graphic-designer' },
    { label: 'Manager', value: 'manager' },
    { label: 'Support Team', value: 'support-team' },
    { label: 'Client Handling', value: 'client-handling' },
    { label: 'Social', value: 'social' },
    { label: 'Marketing', value: 'marketing' }
  ]

  const permissions = [
    { label: 'Agent', value: 'agent' },
    { label: 'Developer', value: 'developer' },
    { label: 'Manager', value: 'manager' },
    { label: 'Support', value: 'support' },
    { label: 'Superadmin', value: 'superadmin' },
    { label: 'Graphics', value: 'graphics' },
    { label: 'Client Handling', value: 'client_handling' },
    { label: 'Social Media', value: 'social' },
    { label: 'Onboarding Admin', value: 'onboarding_admin' },
    { label: 'Client', value: 'client' },
    { label: 'Marketing', value: 'marketing' },
  ]

  const team_tags = teamTags?.map((item) => {
    return {
      label: item?.name,
      value: item?.name?.toLowerCase().replace(/\s+/g, '-'),
    }
  })

  const apps_data = apps?.map(item => ({
    label: item?.name,
    value: item?.app_id
  })) || []

  // Reset form with current data when modal opens
  useEffect(() => {
    if (open && data) {
      setName(data.username || '')
      setEmail(data.email || '')
      setSelectedGeneralType(data.general_type || '')
      setLiveOnApp(data.liveOnApp || 'no')
      setDescription(data.description || '')
      setCalendar(data.calender || '')

      // Set roles
      const roles = data.roles || []
      setSelectedRoles(permissions.filter(p => roles.includes(p.value)))



      // Set apps
      const apps = data.apps || []
      setSelectedApps(apps_data.filter(a =>
        apps.some(app =>
          typeof app === 'string' ? app === a.value : app.value === a.value
        )
      ))
    }
  }, [open, data])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)

    let image_response
    if (e.target?.image?.files?.length > 0) {
      image_response = await uploadImage({
        file: e.target.image.files[0],
        desiredPath: `app/logo/image`,
      })
    }
    var tags_data = e.target.tags ? JSON.parse(e.target.tags.value) : selectedTags.length > 0 ? selectedTags : data?.tags || []
    const payload = {
      _id: data._id,
      username: name,
      email: email,
      roles: selectedRoles.map(role => role.value),
      tags: tags_data,
      general_type: selectedGeneralType,
      image: image_response?.response?.data || data?.image || null,
      apps: selectedApps.map(app => app.value),
      type: 'super_admin_team',
      agency_id: agency?._id,
      liveOnApp: liveOnApp,
      description: description,
      calender: calendar,
    }

    console.log('Updating with:', payload)
    // return

    const { response } = await AppService.auth.UpdateTeam({ payload })

    if (response) {
      setProcessing(false)
      setOpen(false)
      handleRefresh()
    }
  }

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handleOpen}>
        Edit
      </MDButton>

      <MDModal open={open} onClose={handleClose} width={440}>
        <MDBox sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 440,
          maxHeight: '90vh',
          bgcolor: 'background.paper',
          borderRadius: '10px',
          boxShadow: 24,
          p: 4,
          overflowY: 'auto',
        }}>
          <MDTypography variant="h5" mb={2}>
            Edit Staff
          </MDTypography>

          <form onSubmit={handleSubmit}>
            <MDBox sx={{ maxHeight: 'calc(90vh - 100px)', overflowY: 'auto', pr: 1 }}>

              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Name
              </MDTypography>
              <MDInput
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Name"
                fullWidth
                mb={2}
              />

              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Email
              </MDTypography>
              <MDInput
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                fullWidth
                mb={2}
              />

              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Role
              </MDTypography>
              <Multiselect
                data={permissions}
                edit_data={selectedRoles}
                isMulti={true}
                onChange={setSelectedRoles}
                mb={2}
              />

              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                General Type
              </MDTypography>
              <FormControl fullWidth mb={2}>
                <Select
                  value={selectedGeneralType}
                  onChange={(e) => setSelectedGeneralType(e.target.value)}
                >
                  <MenuItem value="">Select a general type</MenuItem>
                  {generalTypes.map((type) => (
                    <MenuItem key={type.value} value={type.value}>
                      {type.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Tags
              </MDTypography>
              <Multiselect
                data={team_tags}
                edit_data={[]}
                isMulti={true}
                name="tags"
                onChange={handleRoleChange}
              />

              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Apps
              </MDTypography>
              <Multiselect
                data={apps_data}
                edit_data={selectedApps}
                isMulti={true}
                onChange={setSelectedApps}
                mb={2}
              />

              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Live on App
              </MDTypography>
              <FormControl fullWidth mb={2}>
                <Select
                  value={liveOnApp}
                  onChange={(e) => setLiveOnApp(e.target.value)}
                >
                  <MenuItem value="yes">Yes</MenuItem>
                  <MenuItem value="no">No</MenuItem>
                </Select>
              </FormControl>

              <MDBox mb={2}>
                <MDTypography variant="button">Description</MDTypography>
                <Editor
                  handleChange={setDescription}
                  data={description}
                />
              </MDBox>

              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Calendar
              </MDTypography>
              <MDInput
                value={calendar}
                onChange={(e) => setCalendar(e.target.value)}
                placeholder="Calendar URL"
                fullWidth
                mb={2}
              />

              <Stack direction="row" alignItems="center" spacing={2} mt={5}>
                <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                  Upload Image +
                  <input hidden name="image" type="file" />
                </Button>
              </Stack>

              <MDBox display="flex" justifyContent="flex-end" mt={3}>
                <MDButton
                  variant="gradient"
                  color="primary"
                  type="button"
                  sx={{ mb: 1 }}
                  onClick={handleClose}
                >
                  Close
                </MDButton>
                <MDButton
                  variant="gradient"
                  color="info"
                  type="submit"
                  sx={{ mb: 1, ml: 1 }}
                  loading={processing}
                  disabled={processing}
                >
                  Update
                </MDButton>
              </MDBox>
            </MDBox>
          </form>
        </MDBox>
      </MDModal>
    </>
  )
}

export default EditModal